module.exports = __webpack_public_path__ + "LGFabout-12.f93d9bc7.png";